module.exports = __webpack_public_path__ + "img/blueTrue.81c55f31.png";